<template>
  <div id="libraryWrapper">
    <div class="columns">
      <div class="column">
        <create-button
          caption="Nieuw item"
          @click="create">
        </create-button>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <table
          v-if="items"
          class="table is-striped is-hoverable is-fullwidth"
        >
          <tr>
            <th>Titel</th>
            <th>Eigenaar</th>
            <th>Gemaakt op</th>
            <th>Laatst gewijzigd op</th>
            <th>Gebruikt in pagina's</th>
            <th></th>
          </tr>

          <tr
              v-for="item in items"
              :key="item.id"
          >
            <td>
              <span class="icon">
                <i
                  class="fas"
                  :class="icons[item.contentable_type]"
                ></i>
              </span>

              {{ item.name }}
            </td>
            <td>{{ item.user.fullName }}</td>
            <td>{{ item.created_at | localized }}</td>
            <td>{{ item.updated_at | localized }}</td>
            <td></td>
            <td>
              <options-buttons
                @edit="edit(item.id)"
                @delete="remove(item.id)"
              />
            </td>
          </tr>
        </table>

        <loading-notification
            v-else
            message="De bibliotheek wordt geladen"
        />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import CreateButton from '@/components/modules/CreateButton'
import OptionsButtons from '@/components/modules/OptionsButtons'
import LoadingNotification from "@/components/modules/LoadingNotification";

export default {
  name: 'Library',

  components: {
    CreateButton,
    OptionsButtons,
    LoadingNotification
  },

  filters: {
    localized(time) {
      return dayjs(time).format('D MMMM YYYY')
    }
  },

  data () {
    return {
      icons: {
        'App\\LibraryText': 'fa-file-alt',
        'App\\LibraryLink': 'fa-link',
        'App\\LibraryFile': 'fa-file-download'
      }
    }
  },

  computed: {
    ...mapGetters({
      items: 'library/items'
    })
  },

  created() {
    this.$store.dispatch('library/loadAll')
  },

  methods: {
    edit(itemId) {
      this.$router.push({ name: 'library.edit', params: { id: itemId } })
    },

    create() {
      this.$router.push({ name: 'library.edit', params: { id: 0 } })
    },

    remove(itemId) {
      this.$store.dispatch('library/remove', itemId)
    },
  }
}
</script>

<style scoped>

</style>
